<template>
  <NavBar
    :active="activeMenyIndex"
    :create_router_to="{name: 'addToStopList', params: {org: $route.params.org} }"
    :create_text="$t('StopLists.AddCompany')"
    :items="list"
    :loading="loading"
    :types="types"
    unload
    @filterItems="filterByTypes"/>
</template>

<script>
import NavBar from 'components/common/blocks/NavBar.vue'
import { storageMixin } from 'mixins'

export default {
  name: 'stopListNavBar',
  mixins: [
    storageMixin
  ],
  data() {
    return {
      activeMenyIndex: 0,
    }
  },
  props: {
    list: Array,
    loading: Boolean,
    filter: Object,
    types: Array
  },
  computed: {
  },
  async mounted() {
    this.$_getPropFromDBStorage('stopLists_menuType', 0)
      .then((menuType) => {
        if (menuType !== this.activeMenyIndex) {
          this.filterByTypes(this.types[menuType])
        }
      })
  },
  methods: {
    filterByTypes(item) {
      const index = this.types.findIndex(i => i.type === item.type)
      if (index !== -1) {
        this.$_savePropToDBStorage('stopLists_menuType', index)
        this.activeMenyIndex = index
        this.$emit('filter', item )
      }
    }
  },
  components: {
    NavBar
  }
}
</script>
